<template>
  <asc-analytic-grid-wrapper
    :title="title"
    :values="values"
    :grid-columns="gridColumns"
    :grid-filters="gridFilters"
    :on-open="onOpen"
  ></asc-analytic-grid-wrapper>
</template>

<script>
import AscAnalyticGridWrapper from '@/components/organisms/AscAnalyticGridWrapper'
import { AscRangeDatePickerMixin, AscGridPropsMixin } from '@/components/mixins'

export default {
  name: 'AscAnalyticGridTemplate',

  components: {
    AscAnalyticGridWrapper,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],
}
</script>
